<template>
  <div>  
    <div id="account-details">
      <div class="login mt-30">
        <div class="login_form_container">
          <div class="account_login_form">
            <form action="#">
              <div class="row">
                <div class="col-md-6 offset-md-3">
                  <label>Contraseña actual</label>
                  <input type="text" name="first-name">  

                  <label class="mt-40">Contraseña nueva</label>
                  <input type="text" name="first-name">
                  <label>Confirmación contraseña nueva</label>
                  <input type="text" name="last-name">
                  <div class="login_submit">
                    <button>Guardar</button>
                  </div>
                </div>                
              </div>              
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    
  }
</script>